import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "General",
    menus: [
      { href: "/about", label: "Mission & People" },
      { href: "/media", label: "Media" },
      { href: "/contact", label: "Contact Us" },
    ],
  },
  {
    id: "1",
    title: "Swing X",
    menus: [
      { href: "/blog-swing-tech", label: "SwingX" },
      { href: "/blog-usecases", label: "Usecases" },
    ],
  },
  {
    id: "2",
    title: "Education",
    menus: [
      { href: "/blog-edu", label: "Overview" },
      { href: "/blog-edu-regular-class", label: "Aerospace 101" },
      { href: "/blog-edu-can-satellites", label: "Can Satellite" },
      { href: "/blog-edu-satellites", label: "Satellite 101" },
      { href: "/blog-edu-satellite-operation", label: "Satellite Ground Control System" },
      { href: "/blog-edu-satellite-image-processing", label: "Satellite Image Processing" },
    ],
  },
  {
    id: "4",
    title: "Cosmogate",
    menus: [
      { href: "/blog-space-themed-park", label: "Overview" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-24 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
    </div>
  );
};

export default Footer;
